import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Stop sign: a galvanized pole with an octagonal red face near the top,
// rimmed white, facing +Z. No lettering — the octagon is the sign.
const GALVANIZED = "#9aa2a6";
const RED = "#b04a3a";
const WHITE = "#e8e6e0";

// An 8-segment cylinder, thetaStart offset so a flat edge sits on top.
function octagon(radius: number, thickness: number): THREE.CylinderGeometry {
  return new THREE.CylinderGeometry(radius, radius, thickness, 8, 1, false, Math.PI / 8);
}

export const stopSign = defineModel({
  id: "stop-sign",
  batchId: "modern",
  name: "Stop sign",
  tags: ["modern", "outdoor", "street", "traffic", "sign"],
  summary: "An octagonal red stop sign on a galvanized pole.",
  description:
    "A street stop sign of the Modern Living kit: a galvanized 2.2 m pole " +
    "carrying an octagonal signal-red face with a thin white rim, facing +Z. " +
    "No lettering — the octagon silhouette reads as the sign.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // Galvanized pole.
      {
        geometry: new THREE.CylinderGeometry(0.03, 0.035, 2.2, 8),
        color: GALVANIZED,
        position: [0, 1.1, 0],
      },
      // White backing octagon — its rim shows as the sign's border.
      {
        geometry: octagon(0.32, 0.025),
        color: WHITE,
        position: [0, 1.85, 0.035],
        rotation: [Math.PI / 2, 0, 0],
      },
      // Red octagon face, proud of the white rim.
      {
        geometry: octagon(0.27, 0.03),
        color: RED,
        position: [0, 1.85, 0.055],
        rotation: [Math.PI / 2, 0, 0],
      },
    ];
  },
  animations: [],
});
